export default "__VITE_ASSET__DhUCjAm6__"